import { useEffect, useState } from "react";
import { availableModels } from "../";

import type { AvailableModels } from "../types";

/**
 * Fetches available conversation models.
 */
export function useAvailableModels() {
  const [models, setModels] = useState<AvailableModels>({ models: [] });

  useEffect(() => {
    const subscription = availableModels().subscribe(setModels);

    return () => subscription.unsubscribe();
  }, []);

  return { availableModels: models };
}

export default useAvailableModels;
